import { render, staticRenderFns } from "./DialogCloseNotice.pug?vue&type=template&id=4d2ea1ff&lang=pug&"
import script from "./DialogCloseNotice.vue?vue&type=script&lang=js&"
export * from "./DialogCloseNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports